// @flow
const CIRCUMFERENCE = 2 * Math.PI * 54;

type Props = {
  progress: number,
};

const KpiCircularProgress = ({ progress }: Props): React$Node => {
  const offset = CIRCUMFERENCE * (1 - progress / 100);
  return (
    <div className="kpi-progress-circle">
      <svg viewBox="0 0 120 120" className="kpi-progress-circle__svg" aria-hidden="true">
        <circle className="kpi-progress-circle__track" cx="60" cy="60" r="54" fill="none" strokeWidth="8" />
        <circle
          className="kpi-progress-circle__fill"
          cx="60" cy="60" r="54"
          fill="none" strokeWidth="8"
          strokeDasharray={ CIRCUMFERENCE }
          strokeDashoffset={ offset }
          strokeLinecap="round"
          transform="rotate(-90 60 60)"
        />
      </svg>
      <span className="kpi-progress-circle__pct">{ Math.round(progress) }%</span>
    </div>
  );
};

export default KpiCircularProgress;
